$(document).ready(function ()
{
  var app = new Vue(
    {
      el: "#body-container",
      data:
      {
        basket: model.basket,
        checkoutDetails: model.checkoutDetails,
        paymentTypes: model.paymentTypes,
        busy: false
      },
      mounted: function()
      {
        clearLoading();
      },
      computed:
      {
        emptyBasket: function()
        {
          return this.basket.itemCount == 0;
        }
      },
      methods:
      {
        setBusy: function (isBusy)
        {
          this.busy = isBusy;
        },
          
        submitForm: function ()
        {
          eventBus.$emit("notify-clear");

          this.$validator.validateAll().then(function (result)
          {
            if (result)
            {
              app.setBusy(true);

              submitForm("/api/basket/createorder", "POST", { RequestVerificationToken: model.antiforgeyToken }, JSON.stringify(app.checkoutDetails))
                  .then(function (data)
                  {
                    if (data && data.redirectUrl && data.redirectUrl !== "")
                    {
                      location.href = data.redirectUrl;
                    }
                  })
                  .catch(function (data)
                  {
                    eventBus.$emit("notify-error", data);
                  })
                  .finally(function()
                  {
                    app.setBusy(false);
                  });
            }
          });
        }
      }
    });
});